
    import { Component, Inject, Vue } from 'vue-property-decorator'
    import Layout from '../../common/components/layout/layout.vue'
    import { mapState } from 'vuex'
    import { BusinessIncome } from '@/app/business-income/entities/business-income.entity'
    import { GetAllBusinessIncomesCommand } from '@/app/business-income/commands/get-all-business-incomes.command'

    @Component({
        components: { Layout },
        metaInfo() {
            return {
                title: 'Inkomensverklaring'
            }
        },
        computed: {
            ...mapState('businessIncome', ['businessIncomes'])
        }
    })
    export default class BusinessIncomeList extends Vue {
        businessIncomes!: BusinessIncome[]

        @Inject() getAllBusinessIncomesCommand!: GetAllBusinessIncomesCommand

        mounted() {
            this.getAllBusinessIncomesCommand.run()
        }
    }
